<template>
  <div class="invoice-related invoice-related-tasks">
    <div v-if="totalItems" class="table-responsive">
      <table class="table table-sm">
        <thead>
          <tr>
            <th width="100">NUMBER</th>
            <th>TASK</th>
            <th width="200">STATUS</th>
            <th width="100">HOURS</th>
            <th width="120" class="text-right">MOVE TO INVOICE</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in relatedItems" :key="index">
            <td>{{ item.id }}</td>
            <td>{{ item.name }}</td>
            <td>{{ item.status | statusToUCWords }}</td>
            <td>{{ item.actual_hours }}</td>
            <td align="right">
              <a v-if="!item.invoiced" href="javascript:;" class="icon-down-arrow" v-tooltip="'Move'" @click="moveToInvoice(index, item.id)"></a>
              <span v-else class="icon-checkmark"></span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <h4 v-else><span v-if="state==''">No related tasks.</span></h4>
  </div>
</template>


<script>
  import {mapGetters} from 'vuex'
  import ServiceInvoice from '@/services/invoice'
  export default {
    data () {
      return {
        state: '',
        relatedItems: [],
        totalItems: 0
      }
    },
    props: ['reload'],
    watch: {
      reload: 'init'
    },
    computed: {
      ...mapGetters(['INVOICE']),
    },
    created () {},
    mounted () {
      this.init();
    },
    methods: {
      init () {
        this.getApprovedItems();
      },
      getApprovedItems () {
        let self = this;
        if (!self.INVOICE.job_id)
          return [];

        let params = {
          job_id: self.INVOICE.job_id,
          status: ['approved', 'completed']
        };
        self.state = 'loading';
        ServiceInvoice.getTasks(self.INVOICE.id, params, resp => {
          self.state = '';
          self.relatedItems = resp;
          self.totalItems = window.numkeys(self.relatedItems);
        });
      },
      moveToInvoice (index, item_id) {
        let self = this;
        ServiceInvoice.moveItemToInvoice(self.INVOICE.id, {type: 'task', id: item_id}, addedInvoiceItem => {
          self.$notify({
            type: 'success',
            text: 'Task moved successfully'
          });
          self.$emit('item-saved', addedInvoiceItem, -1);
          self.relatedItems[index].invoiced = true;
        });
      }
    }
  }
</script>
